import { render, staticRenderFns } from "./PythonCompareView.vue?vue&type=template&id=5580b8a0&"
import script from "./PythonCompareView.vue?vue&type=script&lang=js&"
export * from "./PythonCompareView.vue?vue&type=script&lang=js&"
import style0 from "./PythonCompareView.vue?vue&type=style&index=0&id=5580b8a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports